module.exports = __webpack_public_path__ + "img/tab2.f4b131ed.png";